import React, { useEffect, useState } from 'react';
import { connect } from 'umi';
import { Form, Input, Button } from 'antd';
import { get, isEmpty } from 'lodash';
import useGCPI18n from '@/hooks/useGCPI18n';
import styles from './index.less';

const TransactionOTP = props => {
  // 响应式 hook
  // useResponsive();
  const { sendSMSCode, getSave } = props;
  const [form] = Form.useForm();
  const [time, setTime] = useState(0); // 倒计时
  const [smsCode, setValue] = useState('');
  const isSharePoint = get(props, 'location.state.isSharePoint');
  const GCPI18n = useGCPI18n();

  const sendCode = () => {
    // 发送验证码的时候记录当前时间塞到本地
    setTime(60);
    window.localStorage.setItem('time', new Date().getTime());
    getSave({
      hasGetClick: true,
    });
    // const initAppStr = window.clp?.getLoginInfo() || '{}';
    const initAppStr = window.localStorage.getItem('initApp');
    const initAppObj = JSON.parse(initAppStr) || {};
    // initAppObj.phone = '9202106422';
    // 发送验证码
    sendSMSCode({
      data: {
        businessType: isSharePoint ? 'transfer' : 'pointExchange',
        accNbr: get(initAppObj, 'phone') || '',
      },
    });
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setTime(time <= 0 ? 0 : time - 1);
    }, 1000);
    if (time <= 0) {
      getSave({
        hasGetClick: false,
        hasTimeEnd: true,
      });
    } else {
      getSave({
        hasTimeEnd: false,
      });
    }
    return () => clearTimeout(timer);
  }, [time]);

  useEffect(() => {
    setValue('');
    getSave({
      smsCode: '',
    });
    // 获取本地的时间
    // 不存在，则显示get
    // 存在，与当前时间进行减法，获取剩余时间,
    const currDate = window.localStorage.getItem('time') || '';
    if (!isEmpty(currDate)) {
      const diffTime = new Date().getTime() - currDate;
      const sec = parseInt(diffTime / 1000, 10);
      if (sec > 0) {
        setTime(60 - sec);
      } else {
        setTime(0);
      }
    } else {
      setTime(0);
    }
  }, []);

  const checkValue = e => {
    const inputValue = e.target.value.replace(/[^\d]/g, '');
    setValue(inputValue);
    getSave({
      smsCode: inputValue,
      hasLengthRight: inputValue.length === 6,
      hasGetClick: inputValue.length === 6,
    });
  };

  return (
    <>
      <div className={styles.otpCon}>
        <Form name="basic" autoComplete="off" form={form}>
          <Form.Item>
            <Input
              placeholder={GCPI18n({
                id: 'lb_dito_transaction_otp_page_input_placeholder',
              })}
              maxLength={6}
              onChange={checkValue}
              value={smsCode}
              // type="number"
            />
          </Form.Item>
        </Form>
        <Button className={styles.sendOtpBtn} disabled={time > 0} onClick={sendCode}>
          {time <= 0
            ? GCPI18n({
              id: 'lb_otp_get',
            })
            : `${time}s`}
        </Button>
      </div>
    </>
  );
};
const mapDispatchToProps = dispatch => ({
  // 获取验证码
  sendSMSCode: payload =>
    dispatch({
      type: 'pointShop/sendSMSCode',
      payload,
    }),

  // // 转赠积分
  // getPointTransfer: payload =>
  //   dispatch({
  //     type: 'pointShop/getPointTransfer',
  //     payload,
  //   }),

  getSave: payload =>
    dispatch({
      type: 'pointShop/updateState',
      payload,
    }),
});

export default connect(
  ({ pointShop }) => ({
    pointDetail: pointShop.pointDetail,
  }),
  mapDispatchToProps,
)(TransactionOTP);
